export default __webpack_public_path__ + "static/media/accessibilitat.9aa9920a.svg";